import { Divider, Typography, useTheme } from "@mui/material";

import { Strings } from "@app/constants";

const FooterBottom = () => {
  const theme = useTheme();

  return (
    <>
      <Divider
        sx={{
          width: "100%",
          backgroundColor: theme.palette.common.white,
        }}
      />
      <Typography
        variant="caption"
        color="white"
        textAlign="center"
        sx={{
          fontFamily: "Work Sans",
          fontWeight: "600",
          color: theme.palette.common.white,
          textAlign: "center",
          alignSelf: "center",
        }}
        fontSize={"14"}
      >
        ©{new Date().getFullYear()} {Strings.footer.allRights}
      </Typography>
    </>
  );
};

export { FooterBottom };
